import {FeedbackTag} from "./PublicFeedback";
// application settings update
export class SettingsUpdate {
  // Additional Process Ids for which to collect diagnostics information
  public additionalProcessIds: number[] = [];
  public tags: FeedbackTag[] = [];
}
